import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import {Link} from "react-router-dom";
import {withStore} from "../../hocs";
import {observer} from "mobx-react";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    textAlign: "center",
    p: 4,
};

// @ts-ignore
@withStore
@observer
export default class QuizModalWindowThank extends React.Component {
    componentDidMount() {}

    render() {
        // @ts-ignore
        const {store} = this.props;
        const {openThankWindow,
            handleCloseThankWindow
        } = store?.pageQuizStore


        return (
            <div>
                <Modal
                    open={openThankWindow}
                    onClose={handleCloseThankWindow}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                           Спасибо
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Ваши ответы отправлены
                        </Typography>
                        <Link to="/"><Button onClick={handleCloseThankWindow} >Ок</Button> </Link>
                    </Box>
                </Modal>
            </div>
        )
    }
}